import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import { hideConfirmDialog } from '../features/ui/redux/uiSlices';
import { RootState } from '../store';

const mapStateToProps = (state: RootState) => ({
    confirmDialogProps: state.ui.confirmDialog
});

type Props = ReturnType<typeof mapStateToProps>;

const ConfirmDialog = ({ confirmDialogProps }: Props) => {
    const dispatch = useDispatch();

    if (confirmDialogProps == null) {
        return null;
    }

    const closeClick = () => {
        if (confirmDialogProps.cancelAction != null) {
            dispatch(confirmDialogProps.cancelAction);
        }

        dispatch(hideConfirmDialog());
    };

    const okClick = () => {
        dispatch(confirmDialogProps.okAction);
        dispatch(hideConfirmDialog());
    };

    const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter') {
            okClick();
        } else if (event.key === 'Escape') {
            closeClick();
        }

        event.preventDefault();
    };

    return (
        <Dialog aria-labelledby="simple-dialog-title" open={true} onKeyDown={onKeyDown}>
            <DialogTitle id="simple-dialog-title">{confirmDialogProps.dialogTitle}</DialogTitle>
            <DialogContent>{confirmDialogProps.dialogMessage}</DialogContent>
            <DialogActions>
                <Button onClick={closeClick}>Cancel</Button>
                <Button onClick={okClick} color="primary">
                    {confirmDialogProps.primaryActionName}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default connect(mapStateToProps)(ConfirmDialog);
